import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect, useState, type ReactNode } from 'react';
import { installStaleOnDataWrite } from '@/shared/query/staleOnDataWrite';
import { retryUnlessTimeout } from '@/shared/api/timeout';

export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false,
            // ADR-0077: retry a failed read once, but never one that timed out — PB runs a
            // retrieve once and reports; a second 60 s attempt only doubles the spinner.
            retry: retryUnlessTimeout,
          },
        },
      }),
  );

  // slice-3952: lists re-read after a create/delete made on another page (#3780 et al.).
  useEffect(() => installStaleOnDataWrite(queryClient), [queryClient]);

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
